<template lang="html">
  <div class="splash-container">
    <div class="splash-image">
      <img src="../assets/logo.svg" alt="Logo">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    userToken() {
      return this.$store.getters['auth/userToken'];
    },
  },
};
</script>

<style lang="scss" scoped>
.splash-container {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.splash-image {
  align-items: center;
  justify-content: center;
  margin: auto
}
</style>



// WEBPACK FOOTER //
// src/components/Splash.vue